import { render, staticRenderFns } from "./bear_dialog.vue?vue&type=template&id=62e376e6&scoped=true"
import script from "./bear_dialog.vue?vue&type=script&lang=js"
export * from "./bear_dialog.vue?vue&type=script&lang=js"
import style0 from "./bear_dialog.vue?vue&type=style&index=0&id=62e376e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e376e6",
  null
  
)

export default component.exports